import {
    makeStyles,
} from 'app/tss'

const useStyles = makeStyles()((theme) => {
    return {
        tableContainer: {
            width: '100%',
        },
        cardRoot: {
            height: '100%',
            overflow: 'auto !important',
        },
        cardContent: {
            paddingRight: 0,
            paddingLeft: 0,
        },
        container: {
            minHeight: '200',
            width: '100%',
        },
        header: {
            display: 'flex',
            justifyContent: 'space-between',
            paddingRight: theme.spacing(2),
        },
        icon: {
            cursor: 'pointer',
        },
        link: {
            textDecoration: 'none',
            color: 'inherit',
        },
        tableContent: {
            boxShadow: 'none !important',
        },
        tableContentWrapper: {
            padding: 0,
            borderRadius: 0,
            width: '100%',
            boxSizing: 'border-box',
            border: 'none',
            position: 'static',
        },
        overlay: {
            position: 'absolute',
            left: 0,
            top: 0,
            width: '100%',
            height: '100%',
            background: 'rgba(0,0,0, 0.2)',
        },
        text: {
            color: theme.palette.secondary[600],
        },
        table: {
            minHeight: 200,
        },
        root: {
            height: `calc(100% - ${theme.spacing(4)}) !important`,
            padding: theme.spacing(2),
        },
        chip: {
            paddingTop: `${theme.spacing(0.5)} !important`,
        },
    }
})

export default useStyles
